import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { BarSeries, ChartQueryParams, TimeLineChart } from '@frontend/chart/types';

export class BudgetChartClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchConsumption(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<TimeLineChart> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/consumption`, undefined, true, undefined, queryParams);
        return await this.handleResponse<TimeLineChart>(response);
    }

    public static async fetchConsumptionByProduct(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<BarSeries> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/consumption-by-product`,
            undefined,
            true,
            undefined,
            queryParams
        );
        return await this.handleResponse<BarSeries>(response);
    }

    public static async fetchConsumptionByUser(accountId: string, queryParams?: ApiQueryParams<ChartQueryParams>): Promise<BarSeries> {
        const response = await this.fetchWithQueryParams(`${this.endpoint}/accounts/${accountId}/consumption-by-user`, undefined, true, undefined, queryParams);
        return await this.handleResponse<BarSeries>(response);
    }
}
